import styled, { css } from 'styled-components';
import colors from '../../styles/colors';

const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $fullHeight }) => $fullHeight && css`
    height: 100vh;
  `};
  .MuiCircularProgress-root {
    color: ${colors.base.beta};
  }
`;

export default LoadingWrapper;
